export default "__VITE_ASSET__Cp_P5PWh__"